import { useMemo } from 'react';

import { useLocation } from 'react-router';

import { getShortUrlIdFromUrl } from '../../../../common/helpers';

export function useConferenceId() {
    const { pathname } = useLocation();

    return useMemo(() => {
        const shortUrlId = getShortUrlIdFromUrl(pathname);

        return shortUrlId;
    }, [pathname]);
}
